export interface ChatSummary {
  id: number;
  chatId: string;
  title: string;
  dbId?: string;
  dbName?: string;
  project?: string;
}

export function getSavedChats(): ChatSummary[] {
  const raw = localStorage.getItem("savedChats");
  return raw ? JSON.parse(raw) : [];
}


export function saveSavedChats(chats: ChatSummary[]): void {
  localStorage.setItem("savedChats", JSON.stringify(chats));
}
